// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4eb9eff4","455":"9f39187e"}[chunkId] + ".chunk.js";
};